const titleify = (str: string): string => {
	return str
		.split('-')
		.map((chunk, index) => {
			// Handle known acronyms and brand names
			if (chunk.toLowerCase() === 'ai') {
				return 'AI';
			}
			if (chunk.toLowerCase() === 'rovo') {
				return 'Rovo';
			}
			if (index === 0) {
				return chunk.charAt(0).toUpperCase() + chunk.slice(1);
			}
			return chunk;
		})
		.join(' ');
};

export default titleify;
